import { Box, Button, CircularProgress, Dialog, DialogContent, Grid, Paper, Typography } from "@mui/material"
import { MapType } from "../../../hooks/map.type"
import { COLOR } from "../../../utils/colors"
import { VIEW } from "../../../utils/breakpoint"
import swiftbot from '../../../assets/swiftbot.png';
import { useState } from "react"
import { CheckCircle } from "@mui/icons-material"
import { useAssignRobotMutation, useConfigListRobotToAssign, useListConfigRobotMap } from "../../../hooks/config-page"
import { RobotAssignFormType, RobotType } from "../../../hooks/config-page/robot.type";

type RobotAndMapsType = RobotType & {
  robotMapIds: string[]
}
export default function AssignRobotMapToRobotScreen({
  nextLabel = 'Next',
  onSubmit
}: {
  nextLabel?: string
  onSubmit?: () => void
}) {
  // const [robotAndMaps, setRobotAndMaps] = useState<RobotAndMapsType[]>(robots.map((item) => ({ ...item, robotMapIds: [] })))
  const [selectedRobot, setSelectedRobot] = useState<RobotType>()
  // const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])

  const [selectedWantToAssign, setSelectedWantToAssign] = useState<MapType[]>([])
  const [selectedWantToUnassign, setSelectedWantToUnassign] = useState<MapType[]>([])

  const { data: robotListToAssign, refetch: refetchRobotList } = useConfigListRobotToAssign()
  const { data: robotMapData, refetch: refetchRobotMap } = useListConfigRobotMap({
    page_size: 1000
  })

  const { trigger: submitAssignRobot, isLoading } = useAssignRobotMutation({
    onSuccess: () => {
      setSelectedRobot(undefined)
      setSelectedWantToAssign([])
      setSelectedWantToUnassign([])
      refetchRobotList()
      refetchRobotMap()
      onSubmit?.()
    }
  })

  const listRobotToAssigns = robotListToAssign?.robots || []
  const listRobotMaps = robotMapData?.data || []
  
  const currentRobotMaps = selectedRobot?.robot_maps || []
  const onToggleRobotMaps = (item: MapType) => {
    if (!selectedRobot) {
      return
    }
    const isAlreadySelected = selectedWantToAssign.find((map) => map.map_uuid === item.map_uuid)
    if (isAlreadySelected) {
      // If already selected to assign, unselect it
      const newSelected = selectedWantToAssign.filter((map) => map.map_uuid !== item.map_uuid)
      setSelectedWantToAssign(newSelected)
      return
    }

    const isAlreadyUnassign = selectedWantToUnassign.find((map) => map.map_uuid === item.map_uuid)
    if (isAlreadyUnassign) {
      // If already selected to unassign, unselect it
      const newSelected = selectedWantToUnassign.filter((map) => map.map_uuid !== item.map_uuid)
      setSelectedWantToUnassign(newSelected)
      return
    }

    if (!isAlreadySelected && !isAlreadyUnassign) {
      // Check if the map is already assigned to the robot
      const isInCurrent = currentRobotMaps.find((map) => map.map_uuid === item.map_uuid)

      if (isInCurrent) {
        // If it's in current assigned maps, mark it for unassignment
        setSelectedWantToUnassign([...selectedWantToUnassign, item])
      } else {
        // If it's not in current assigned maps, mark it for assignment
        setSelectedWantToAssign([...selectedWantToAssign, item])
      }
    }

  }

  const isSelected = (item: MapType) => {
    const isAlreadySelected = selectedWantToAssign.find((map) => map.map_uuid === item.map_uuid)
    if (isAlreadySelected) {
      return true
    }
    const isAlreadyUnassign = selectedWantToUnassign.find((map) => map.map_uuid === item.map_uuid)
    if (isAlreadyUnassign) {
      return false
    }

    // If not in either, check if it's in current assigned maps
    const isInCurrent = currentRobotMaps.find((map) => map.map_uuid === item.map_uuid)
    return !!isInCurrent
  }

  const onSaveChange = () => {
    if (!selectedRobot) {
      return
    }

    // setSelectedRobot(undefined)

    const form: RobotAssignFormType = {
      robot_mac: selectedRobot.robot_mac,
      assign_map_uuids: selectedWantToAssign.map((item) => item.map_uuid),
      unassign_map_uuids: selectedWantToUnassign.map((item) => item.map_uuid),
    }

    submitAssignRobot(form)
  }

  const onDetail = (item: RobotType) => {
    setSelectedRobot(item)
  }

  const onCancel = () => {
    setSelectedRobot(undefined)
    setSelectedWantToAssign([])
    setSelectedWantToUnassign([])
  }

  const onHandleSubmit = () => {
    onSubmit?.()
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      },
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '90vh', gap: '24px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', borderRadius: '12px', flexDirection: 'column', mb: '12px' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Assign Robot Maps to Robot
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: COLOR.neutral[900],
                opacity: 0.6,
              }}
            >
              Select the Robot to assign the Robot Map
            </Typography>
          </Box>
        </Box>
        <Box sx={{
          flex: 'auto',
          height: '100%',
          minHeight: '100px'
        }}>
          <Grid container spacing={2}>
            {listRobotToAssigns.map((item, index) => (
              <Grid item xs={6} sm={3} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    padding: '24px',
                    cursor: 'pointer',
                  }}
                  onClick={() => onDetail(item)}
                >
                  <img src={swiftbot} alt={item.robot_name} style={{ width: '100%', height: '200px', objectFit: 'scale-down' }} />
                  <Typography sx={{ fontFamily: "Poppins", mt: '16px', fontSize: '18px', fontWeight: 500, color: COLOR.black }}>{item.robot_name}</Typography>
                  <Box sx={{ minHeight: '48px', display: 'flex', mt: '4px', flexDirection: 'row', alignItems: 'center', gap: '6px' }}>
                    {item.robot_maps.length > 0 ? (
                      <CheckCircle fontSize="small" color="success" />
                    ) : (
                      <Box sx={{ width: '14px', height: '14px', borderRadius: '999px', flex: 'none', border: '1px dashed black' }}></Box>
                    )}
                    <Typography>{item.robot_maps.length} {item.robot_maps.length > 1 ? "Maps" : "Map"} Assigned</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
        {nextLabel !== '' && (
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button onClick={onHandleSubmit} variant="contained">{nextLabel}</Button>
          </Box>
        )}
      </Box>

      <Dialog open={!!selectedRobot} onClose={() => onCancel()} sx={{}} maxWidth={'lg'}>
        {selectedRobot && (
          <DialogContent sx={{ padding: '28px', backgroundColor: '#F8F8F8' }}>
            <Box sx={{ display: 'flex', mt: '4px', flexDirection: 'row', alignItems: 'center', gap: '48px', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={{ fontFamily: "Poppins", fontSize: '18px', fontWeight: 600, color: COLOR.black }}>
                  View Robot Current Map Assignment
                </Typography>
                <Typography sx={{ fontFamily: "Poppins", fontSize: '14px', fontWeight: 400, color: COLOR.black, opacity: 0.6 }}>
                  Select the Robot Map to assign with this Robot ({selectedRobot.robot_name})
                </Typography>
              </Box>
              <Button onClick={() => onSaveChange()} variant="contained" disabled={isLoading} startIcon={isLoading && <CircularProgress size={16} sx={{ color: COLOR.white }} />}>
                Save Changes
              </Button>
            </Box>
            <Box sx={{ display: 'flex', mt: '28px', width: '100%', flexDirection: 'row', gap: '24px', justifyContent: 'space-between' }}>
              <Box sx={{ flex: 'none' }}>
                <Paper
                  elevation={1}
                  sx={{
                    padding: '24px',
                    cursor: 'pointer'
                  }}
                >
                  <img src={swiftbot} alt={selectedRobot.robot_name} style={{ width: '100%', height: '180px', objectFit: 'scale-down' }} />
                  <Typography sx={{ fontFamily: "Poppins", mt: '16px', fontSize: '18px', fontWeight: 500, color: COLOR.black }}>{selectedRobot.robot_name}</Typography>
                  <Box sx={{ display: 'flex', mt: '4px', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                    {selectedRobot.robot_maps.length > 0 ? (
                      <CheckCircle fontSize="small" color="success" />
                    ) : (
                      <Box sx={{ width: '14px', height: '14px', borderRadius: '999px', flex: 'none', border: '1px dashed black' }}></Box>
                    )}
                    <Typography>{selectedRobot.robot_maps.length} {selectedRobot.robot_maps.length > 1 ? "Maps" : "Map"} Assigned</Typography>
                  </Box>
                </Paper>
              </Box>
              <div style={{ width: '1px', borderRadius: '999px', height: '60vh', backgroundColor: COLOR.gray[300] }}></div>
              <Box sx={{ flex: 'auto' }}>
                <Grid container spacing={2}>
                  {listRobotMaps.map((item, index) => (
                    <Grid key={index} item xs={6} md={4} height={'100%'}>
                      <Paper
                        elevation={0}
                        sx={{
                          padding: '24px',
                          cursor: 'pointer',
                          minWidth: '200px',
                          border: isSelected(item) ? `1px solid ${COLOR.accent.blue}` : 'transparent',
                          backgroundColor: isSelected(item) ? '#F8FBFF' : COLOR.white,
                          minHeight: '320px'
                        }}
                        onClick={() => onToggleRobotMaps(item)}
                      >
                        <Box sx={{ backgroundColor: COLOR.gray[200], padding: '12px' }}>
                          <img
                            // src={item.map_image}
                            src={item.map_image}
                            alt={item.map_name}
                            style={{ width: '100%', height: '180px', objectFit: 'scale-down' }}
                          />
                        </Box>
                        <Typography sx={{ fontFamily: "Poppins", mt: '16px', fontSize: '18px', fontWeight: 500, color: COLOR.black }}>
                          {item.building}#{item.map_name_display}
                        </Typography>
                        <Box sx={{ display: 'flex', mt: '4px', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                          <Typography>Origin by: {item.robot_detail?.robot_name}</Typography>
                          {item.robot === selectedRobot.robot_mac && (
                            <CheckCircle fontSize="small" color="success" />
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </DialogContent>
        )}
      </Dialog>
    </Box>
  )
}